import { Injectable } from '@angular/core';
import {StamdataStatusEnum} from "src/app/api/models/OK/Egis/Service/Models/Entities/Enums/stamdata-status-enum";

@Injectable({
  providedIn: 'root'
})
export class StamdataStatusService {

  constructor() { }

  public stamdatastatus(statusEnum: StamdataStatusEnum) {
    switch (statusEnum) {
      case StamdataStatusEnum.Yes:
        return "Ja";
      case StamdataStatusEnum.No:
        return "Nej";
      case StamdataStatusEnum.Maybe:
        return "Måske";
    }
  }
}
